export class ValidationService {
    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
        let config = {
            'required': 'Obligatorio',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Correo electrónico no válido',
            'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
            'minlength': `Longitud minima ${validatorValue.requiredLength}`,
            'maxlength': `Longitud maxima ${validatorValue.requiredLength}`,
            'invalidNumber': 'Permitido solo numeros.',
            'invalidRfc': 'RFC no válido',
            'invalidcpostal':'Codigo postal requerido'
        };
        return config[validatorName];
    }

    static creditCardValidator(control) {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
            return null;
        } else {
            return { 'invalidCreditCard': true };
        }
    }

    static emailValidator(control) {
        // RFC 2822 compliant regex
        if (control.value != null && control.value != '') {
            if (control.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                return null;
            } else {
                return { 'invalidEmailAddress': true };
            }
        } else {
            return null;
        }
    }

    static passwordValidator(control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            return null;
        } else {
            return { 'invalidPassword': true };
        }
    }
    static numberValidator(control) {
        if (control.value != null && control.value != '') {
            if (control.value.match(/^-?[\d.]+(?:e-?\d+)?$/)) {
                return null;
            } else {
                return { 'invalidNumber': true };
            }
        } else {
            return;
        }

    }
    static rfcValidator(control) {
        if (control.value != null && control.value != '') {
            if (control.value.match(/^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\w{2})([A|a|0-9]{1})$/)) {
                return null;
            } else {
                return { 'invalidRfc': true };
            }
        } else {
            return null;
        }
    }
    static cpostalValidator(control){
        if (control.value != null && control.value != '') {

        }else{
            return { 'required': true };
        }
    }
    
    static validRegimen(control){
        if (control.value != null && control.value != '') {

        }else{
            return { 'required': true };
        }
    }
}
